// src/components/Enrollments/EnrollmentsPage.jsx
// ============================================================================
// BLOCK ENR.PAGEWRAP.0 — Route-level wrapper for Enrollments
// ----------------------------------------------------------------------------
// PURPOSE
//  - Keep the route import aligned with the rest of the application.
// ============================================================================

import React from 'react';

import Enrollments from './Enrollments.jsx';

function EnrollmentsPage() {
  return <Enrollments />;
}

export default React.memo(EnrollmentsPage);
